export const identity = {
  handle: "jvnko",
  role: "homelab · mail · osu · radio electronics · weird computers",
  langs: ["RU", "EN"] as const,
  host: "jvnko.boats",
  updated: "2026-10",
};

export type WhoamiField = {
  key: string;
  value: string;
  href?: string;
};

export const whoami: WhoamiField[] = [
  { key: "handle", value: "jvnko" },
  { key: "aka", value: "vibesnow" },
  { key: "host", value: "jvnko.boats" },
  { key: "languages", value: "RU, EN" },
  { key: "study", value: "radio electronics · devices & circuits" },
  { key: "role", value: "homelab founder · jvnkod · jvnkosu!" },
  {
    key: "mail",
    value: "vibesnow@jvnko.boats",
    href: "mailto:vibesnow@jvnko.boats",
  },
  {
    key: "jvnkosu!",
    value: "vibesnow",
    href: "https://osu.jvnko.boats/users/vibesnow",
  },
  {
    key: "osu!",
    value: "vibesnow",
    href: "https://osu.ppy.sh/users/vibesnow",
  },
  {
    key: "git",
    value: "gitea.jvnko.boats/vibesnow",
    href: "https://gitea.jvnko.boats/vibesnow",
  },
  {
    key: "steam",
    value: "main profile",
    href: "https://steamcommunity.com/profiles/76561199097121278/",
  },
  {
    key: "steam/cs2",
    value: "800 DPI · 2.0 / 1.11 scope",
    href: "https://steamcommunity.com/profiles/76561198766266095/",
  },
];

export const stack = {
  langs: "Go · Rust · C",
  os: "Arch · Alpine · OpenWrt + Limine · OpenBSD",
  tags: "self-host · DevOps · VoIP · game servers · hardware",
};

export const ops = [
  "DE premium VPS · VLESS / Reality / Hysteria · split routing",
  "VoIP · Cisco SPA122 + FreePBX / Asterisk container",
  "jvnkosu! server code · spectator stats · MC Forge / modpacks",
  "SMD soldering · phone modding · APatch / KernelSU · headless terminals",
];

export type Service = {
  id: string;
  name: string;
  host: string;
  href: string;
  note: string;
};

export const services: Service[] = [
  {
    id: "osu",
    name: "osu",
    host: "osu.jvnko.boats",
    href: "https://osu.jvnko.boats/",
    note: "jvnkosu! · founder",
  },
  {
    id: "git",
    name: "git",
    host: "gitea.jvnko.boats",
    href: "https://gitea.jvnko.boats/",
    note: "gitea · vibesnow",
  },
  {
    id: "chat",
    name: "chat",
    host: "chat.jvnko.boats",
    href: "https://chat.jvnko.boats/",
    note: "matrix",
  },
];

export type Project = {
  name: string;
  blurb: string;
  href?: string;
};

/** Public repos + in-progress work. Founder/maintainer where applicable. */
export const projects: Project[] = [
  {
    name: "JvnkoMailCore",
    href: "https://gitea.jvnko.boats/vibesnow/JvnkoMail",
    blurb: "Go mail engine · jvnkod · spam filters · founder",
  },
  {
    name: "jvnkosu!",
    href: "https://gitea.jvnko.boats/jvnkosu",
    blurb: "private osu!(lazer) · founder & maintainer",
  },
  {
    name: "DialJvne",
    href: "https://gitea.jvnko.boats/vibesnow/DialJvne",
    blurb: "SIP softmodem · JvneLink FSK/QAM over RTP",
  },
  {
    name: "JvneOS",
    blurb: "custom OS · OpenBSD 7.9 base · QEMU lab",
  },
  {
    name: "Luma",
    blurb: "network emulation stack · Go",
  },
  {
    name: "PS1 emu",
    blurb: "PlayStation 1 emulator from scratch · Rust / Cargo",
  },
  {
    name: "server-watch",
    blurb: "telegram server monitoring · collab",
  },
];

export const gear = {
  desktop: [
    "CPU   AMD Ryzen 7 5700X",
    "GPU   Gigabyte RTX 4060 Eagle OC 8 GB",
    "RAM   4×8 GB Corsair Vengeance LPX 2666 MHz",
    "MB    ASRock Steel Legend B450M",
    "PSU   DeepCool PK750D",
    "NVMe  Movespeed 512 GB · Netac SSD 512 GB",
    "HDD   Samsung HM500JI 500 GB · WD 10EZEX 1 TB",
    "case  Ardor Gaming Crystal CM2",
  ],
  storage: [
    "Seagate Laptop Thin 1 TB",
    "Seagate Momentum Thin 320 GB",
  ],
  /** dead / dying disks — SMART horror stories only */
  graveyard: [
    "Toshiba S300 Surveillance 2 TB (HDWT720UZSVA) · ~189 realloc · paperweight",
    "XP-Pen Star G640 · USB port gave up first",
  ],
  displays: [
    "primary   Titan Army P2510H Pro+ 24.5\"",
    "secondary DEXP FF201H 19.5\"",
  ],
  input: [
    "keyboard  IO by Red Square Type 68 Magnetic (black)",
    "mouse     IO by Red Square Airox",
    "tablet    Huion H430P",
  ],
  vr: ["Pico 4 Ultra 12/256"],
  laptop: [
    "Mi Notebook Lite 15.6",
    "CPU  Intel Core i7-8550U · RAM 2×8 GB",
    "GPU  NVIDIA MX110 2 GB",
    "OS   macOS Tahoe 26.6.2",
  ],
  routers: ["Huawei BE3 Pro", "Redmi AC2100 · OpenWrt"],
  mobile: [
    "Xiaomi Poco F5 12/256 (primary)",
    "iPhone 11 64 GB green",
    "iPhone 8 256 GB gold · hacktivated",
  ],
  audio: "iBasso DX200 + AMP1 · Moondrop Chu 2",
  telephony: "Panasonic TG-KX6411RU · Cisco SPA122",
  notes: [
    "cs2 sens · 800 DPI · 2.0 hipfire · 1.11 scope",
    "full Red Square desk stack now (keys + mouse)",
  ],
};

export const banner = String.raw`
      ██ ██    ██ ███    ██ ██   ██  ██████
      ██ ██    ██ ████   ██ ██  ██  ██    ██
      ██ ██    ██ ██ ██  ██ █████   ██    ██
 ██   ██  ██  ██  ██  ██ ██ ██  ██  ██    ██
  █████    ████   ██   ████ ██   ██  ██████
`.replace(/^\n/, "");

export const boat = String.raw`
                   |    |    |
                  )_)  )_)  )_)
                 )___))___))___)\
                )____)____)_____)\\
              _____|____|____|____\\\__
     ---------\                   /---------
       ^^^^^ ^^^^^^^^^^^^^^^^^^^^^
         ^^^^      ^^^^     ^^^    ^^
              ^^^^      ^^^
`;
